function Circle(){
  return (
    <div className="clickable__totem clickable__totem--circle"></div>
  )
}

export default Circle;
